<template>
  <filter-wrapper>
    <z-form ref="form" @submit.prevent.native="submit">
      <template slot="default">
        <div class="filter__row">
          <div class="filter__item col-2">
            <label class="filter__item__title">
              {{ $t('stats.statistics.general.filter.group_by.title') }}
            </label>
            <z-form-input
              class="filter__item__body"
              :rules="{ required: true }"
              :show_errors="false"
            >
              <i-select v-model="form.group_by">
                <i-option
                  v-for="(label, key) in $t('stats.statistics.general.filter.group_by.values')"
                  :key="key"
                  :value="key"
                  :label="label"
                />
              </i-select>
            </z-form-input>
          </div>

          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('stats.statistics.general.filter.assigned.title') }}
            </label>
            <z-form-input
              class="filter__item__body"
              :show_errors="false"
            >
              <assigned-select v-model='form.assigned' />
            </z-form-input>
          </div>

          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('stats.statistics.general.filter.project.title') }}
            </label>
            <z-form-input
              class="filter__item__body"
              :show_errors="false"
            >
              <project-select v-model='form.project' />
            </z-form-input>
          </div>

          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('tasks.campaign.filter.status.title') }}
            </label>
            <div class="filter__item__body">
              <i-select v-model="form.state_id" :clearable="true">
                <i-option
                  v-for="(item, key) in statesList"
                  :key="key"
                  :value="item.id"
                  :label="item.name"
                />
              </i-select>
            </div>
          </div>
        </div>

        <div class="filter__row">
          <div class="filter__item filter__item--datepicker col-5">
            <label class="filter__item__title">
              {{ $t('shared.component.filter.period') }}
            </label>
            <z-form-input class="filter__item__body">
              <date-range-picker v-model="form.date" :clearable="false" />
            </z-form-input>
          </div>
          <div class="filter__item filter__item--button">
            <i-button html-type="submit" type="primary" size="large">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
        </div>
      </template>
    </z-form>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import AssignedSelect from '@stats/components/input-assigned-select';
  import ProjectSelect from '@stats/components/input-project-select';
  import { StatusesService } from '@administration/services/StatusesService';
  import { mapActions } from 'vuex';
  // import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper,
      AssignedSelect,
      ProjectSelect
    },
    data() {
      return {
        statesList: [],
        form: {
          group_by: 'date',
          trunk_id: null,
          assigned: '',
          project: '',
          state_id: '',
          country_code: null,
          date: null
        }
      };
    },

    async created() {
      await StatusesService.getList().then(resp => this.statesList = resp.data);
    },

    methods: {
      ...mapActions('stats/table', ['search']),

      submit: function() {
        this.$emit('getGroupBy', this.form.group_by);
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const { start, end } = parseSearchStateByPeriod(this.form.date);
            const { group_by, assigned, project, state_id } = this.form;

            const params = {
              group_by: group_by,
              date_from: start,
              date_to: end,
              project_ids: [project],
              assigned_to: [assigned],
              task_state_ids: [state_id]
            };

            if( !params.project_ids[0] ) delete params.project_ids
            if( !params.assigned_to[0] ) delete params.assigned_to
            if( !params.task_state_ids[0] ) delete params.task_state_ids

            this.search(params);
          }
        });
      }
    }
  };
</script>
